
import Services from './base-services'

const service = new Services('additional-demographics2')

export default {
  listFromSuite: () => {
    return service.suiteOperation(() => service.get('list'))
  }
}
